import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CustomCursor() {
    const mx = useMotionValue(-100);
    const my = useMotionValue(-100);
    const x = useSpring(mx, { stiffness: 400, damping: 40, mass: 0.4 });
    const y = useSpring(my, { stiffness: 400, damping: 40, mass: 0.4 });
    const [hovering, setHovering] = useState(false);
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        // Only enable on fine pointer devices
        const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
        setEnabled(fine);
        if (!fine) return;

        const onMove = (e) => { mx.set(e.clientX); my.set(e.clientY); };
        const onOver = (e) => {
            const el = e.target;
            const interactive = el.closest("a, button, [data-cursor='hover'], [role='button']");
            setHovering(!!interactive);
        };
        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseover", onOver);
        return () => {
            window.removeEventListener("mousemove", onMove);
            window.removeEventListener("mouseover", onOver);
        };
    }, [mx, my]);

    if (!enabled) return null;

    return (
        <>
            <motion.div
                style={{ x, y }}
                className="pointer-events-none fixed left-0 top-0 z-[90] -translate-x-1/2 -translate-y-1/2"
                data-testid="custom-cursor"
            >
                <motion.div
                    animate={{ scale: hovering ? 2.6 : 1, opacity: hovering ? 0.4 : 1 }}
                    transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
                    className="h-3 w-3 rounded-full bg-sb-mint"
                    style={{ boxShadow: "0 0 20px rgb(var(--sb-mint) / 0.6)" }}
                />
            </motion.div>
            <motion.div
                style={{ x, y }}
                className="pointer-events-none fixed left-0 top-0 z-[89] -translate-x-1/2 -translate-y-1/2 mix-blend-difference"
            >
                <motion.div
                    animate={{ scale: hovering ? 0.5 : 1 }}
                    transition={{ duration: 0.25 }}
                    className="h-9 w-9 rounded-full border"
                    style={{ borderColor: "rgba(255,255,255,0.4)" }}
                />
            </motion.div>
        </>
    );
}
